var map = {
	"./Patsnap.svg": 18206,
	"./academy_cn.svg": 99813,
	"./academy_en.svg": 1275,
	"./analytics_cn.svg": 43527,
	"./analytics_en.svg": 95257,
	"./bio_cn.svg": 67825,
	"./bio_en.svg": 38591,
	"./chemical_cn.svg": 27513,
	"./chemical_en.svg": 75783,
	"./community_cn.svg": 67202,
	"./community_en.svg": 72504,
	"./course2b_cn.svg": 50932,
	"./course2b_en.svg": 88390,
	"./discovery_cn.svg": 66421,
	"./discovery_en.svg": 84843,
	"./eureka_cn.svg": 87166,
	"./eureka_en.svg": 78764,
	"./help_center_cn.svg": 55366,
	"./help_center_en.svg": 9460,
	"./innocloud_cn.svg": 27586,
	"./innocloud_en.svg": 75864,
	"./innosnap_cn.svg": 92493,
	"./innosnap_en.svg": 47715,
	"./insights_cn.svg": 61312,
	"./insights_en.svg": 29226,
	"./ls360_cn.svg": 36027,
	"./ls360_en.svg": 50917,
	"./synapse_cn.svg": 74912,
	"./synapse_en.svg": 42826,
	"./tffi_cn.svg": 70538,
	"./tffi_en.svg": 28800,
	"./yunchuang_cn.svg": 9693,
	"./yunchuang_en.svg": 73235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67131;